import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0A08] text-[#FBF9F5] grid place-items-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-white/10 grid place-items-center">
          <XCircle size={40} className="text-white/70"/>
        </div>
        <h1 className="mt-6 font-serif-display text-3xl font-black">Pagamento annullato</h1>
        <p className="mt-3 text-white/70">Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.</p>
        <div className="mt-6 flex flex-col gap-2">
          <Link to="/choose-plan" data-testid="cancel-retry-btn" className="w-full bg-gradient-to-r from-[#D99B26] to-[#C85A32] hover:brightness-110 text-white rounded-full py-3 font-black">Torna alla scelta piano</Link>
          <Link to="/dashboard" className="w-full border border-white/20 text-white/80 rounded-full py-3 font-semibold">Vai al Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
